define('Store.Cart.EntryPoint', [
	'Backbone.View',
	'Header.MiniCart.View',
	'SC.Configuration',
	'Store.Cart.CartDisableError.View',
	'Store.Cart.StateObserver',
	'Store.LiveOrder.Helper',
	'underscore',
	'Utils',
	'Store.Transaction.Line.Views.Price.View'
], function StoreCartEntryPoint(
	BackboneView,
	MiniCartView,
	Configuration,
	StoreCartCartDisableErrorView,
	StoreCartObserver,
	LiveOrderHelper,
	_,
	Utils
) {
	'use strict';

	MiniCartView.addExtraContextProperty = BackboneView.addExtraContextProperty;

	return {
		mountToApp: function mountToApp(application) {
			var cart = application.getComponent('Cart');
			var layout = application.getComponent('Layout');

			cart.addToViewContextDefinition('Cart.Summary.View', 'cartDisabledMessage', 'string', function cartDisabledMessage() {
				return Configuration.get('store.selector.messages.cartDisabledButton');
			});

			cart.getLines().then(function getLines() {
				if (!LiveOrderHelper.isReadyToCheckout() || LiveOrderHelper.hasPriceChanged()) {
					layout.addChildView('CartDisableError', function addChildView() {
						return new StoreCartCartDisableErrorView();
					});
				}
			});

			cart.addToViewContextDefinition('Cart.Detailed.View', 'cartDisabledItemsMessage', 'string', function cartDisabledItemsMessage() {
				return Configuration.get('store.selector.messages.cartDisabledItems');
			});

			cart.addToViewContextDefinition('Cart.Summary.View', 'isDisabled', 'boolean', function isDisabledSummary() {
				return !LiveOrderHelper.isReadyToCheckout();
			});

			layout.addToViewContextDefinition('Cart.Lines.View', 'hasPriceChanged', 'boolean', function isDisabledActions(ctx) {
				return LiveOrderHelper.hasLinePriceChanged(ctx.line);
			});
			cart.addToViewContextDefinition('Cart.Lines.View', 'priceChangedMessage', 'boolean', function isDisabledSummary(ctx) {
				return Utils.translate('Price has changed when changing store');
			});

			cart.addToViewContextDefinition('Cart.Lines.View', 'unavailabilityMessage', 'boolean', function isDisabledSummary(ctx) {
				return ctx.line.item.keyMapping_notSoldInStoreMessage;
			});

			layout.addToViewContextDefinition('Header.MiniCart.View', 'isDisabled', 'boolean', function isDisabledSummary() {
				return !LiveOrderHelper.isReadyToCheckout();
			});
			layout.addToViewContextDefinition('Cart.Lines.View', 'isDisabled', 'boolean', function isDisabledActions(ctx) {
				return ctx.line.item.storePurchasable === false;
			});
			layout.addToViewContextDefinition('Cart.Item.Actions.View', 'isDisabled', 'boolean', function isDisabledActions(ctx) {
				return ctx.line.item.storePurchasable === false;
			});

			cart.addToViewEventsDefinition('Cart.Lines.View', 'click [data-action="change-location"]', function fnChangeLocation() {
				application.openStoreDropdown();
			});

			layout.addToViewContextDefinition('ProductList.DetailsLaterMacro.View', 'unavailabilityMessage', 'boolean', function (ctx) {
				return ctx.model.item.keyMapping_notSoldInStoreMessage;
			});

			StoreCartObserver.hookRedirectListener(application);
		}
	};
});
